import { fansupportPrivate } from "../index";

export const getUserDetails = async () => {
    try {
        const response = await fansupportPrivate.get('/identity/user-details');
        return response;
    } catch (error) {
        console.log("getUserDetails",error);
    }
}